import AirtableTable from "../AirtableTable";
import { Week } from "../models";
import { airtableFields, airtableTables } from "../schema";

export class WeekTable extends AirtableTable<Week> {
  	constructor(instance: any) {
		super(instance, airtableTables.weeks);

		this.fields = [
			airtableFields.weeks.week, airtableFields.weeks.course, airtableFields.weeks.unit,
			airtableFields.weeks.powerpoint, airtableFields.weeks.downloadedBy
		]
	}

	getAll = () => {
		return this.list({
			sort: [{
			  field: airtableFields.weeks.week,
			  direction: "asc"
			}]
		})
	}

	getByCourse = (course: string) => {
		return this.listAll().then((items: any[]) => items.filter((item) => item[airtableFields.weeks.course] === course));
	}

	getByUnit = (unit: string) => {
		return this.listAll().then((items: any[]) => items.filter((item) => item[airtableFields.weeks.unit] === unit));
	}
}
